"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.IconButton = void 0;
var react_1 = __importDefault(require("react"));
var GenericButton_1 = __importDefault(require("./components/GenericButton"));
/**
 * {@link https://cultureamp.design/components/icon-button/ Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/docs/components-button--default-kaizen-demo-icon Storybook}
 */
var IconButton = function (props) { return (react_1["default"].createElement(GenericButton_1["default"], __assign({ iconButton: true }, props))); };
exports.IconButton = IconButton;
exports.IconButton.defaultProps = {
    primary: false,
    destructive: false,
    disabled: false,
    reversed: false,
    secondary: false
};
exports.IconButton.displayName = "IconButton";
//# sourceMappingURL=IconButton.js.map